import React, { useContext, useEffect, useMemo, useState } from 'react'
import styled from 'styled-components';
import { useDevice } from '../contexts/DeviceContext';
import { AuthContext } from '../contexts/AuthContext';
import { DataContext } from '../contexts/DataContext';
import { useParams } from 'react-router-dom';
import AppPage from '../layouts/AppPage';
import { COVER_URL, DEFAULT_TITLE } from '../lib/settings';
import IssueIntro from '../components/IssueIntro';
import SectionMobile from '../components/SectionMobile';
import SectionDesktop from '../components/SectionDesktop';
import PageNotFound from './PageNotFound';
import { metaTags } from '../lib/utils/metaTags';

export default function Issue() {
  const { isMobile } = useDevice();
  const { api } = useContext(AuthContext);
  const { issues, setIssues, setCurrentIssueIndex, setIssueIds } = useContext(DataContext);
  const [notFound, setNotFound] = useState(false);
  const { id } = useParams();

  const issue = issues && issues[id];

  useEffect(() => {
    if (issues && issues[id]) return;
    const getIssueWithAllIds = async () => {
      try {
        const issueId = parseInt(id);
        const response = await api.getIssueWithPieces(issueId, true);
        const { issue, issuesIds } = response.data;
        setIssueIds(issuesIds);
        setCurrentIssueIndex(null);
        setIssues({
          ...(issues || {}),
          [issue.id]: issue,
        });
      } catch (error) {
        if (error.response?.status === 404) {
          setNotFound(true);
        }
      };
    }
    getIssueWithAllIds();
  }, [api, id, issues, setIssues, setIssueIds, setCurrentIssueIndex, setNotFound])

  const MetaTags = useMemo(() => {
    return metaTags({
      title: `${DEFAULT_TITLE} ${issue ? `| ${issue.title}` : ''}`,
      description: issue?.annotation,
      image: issue?.image_path,
      url: `https://chimeras.world/issues/${id}`
    })
  }, [id, issue]);

  return (
    <>
      {notFound ? <PageNotFound /> : (
    <AppPage>
      {MetaTags}
      <MAIN>
      <div className="cover-container">
        <img src={COVER_URL} alt="Chimeras Cover" />
      </div>
      <div>
        {issue &&
        <div>
          <IssueIntro
            issueNum={issue.issue_number}
            date={issue.issue_date}
            imgSrc={issue.image_path}
            title={issue.title}
            annotation={issue.annotation}
            disableSwitches={true}
          />
          <div className="sections">
            {issue.blocks?.map((block, index) => (
              isMobile ? 
                <React.Suspense fallback={null} key={index}>
                  <SectionMobile key={index} {...block} />
                </React.Suspense>
              : <SectionDesktop key={index} {...block} />
            ))}
          </div>
        </div>
        }
      </div>
      </MAIN>
    </AppPage>
      )}
    </>
  )
}

const MAIN = styled.div`
  & > .cover-container {
    background-color: var(blue);
    width: 100vw;
    min-height: calc(100vw * 0.5015625);

    img {
      width: 100%;
    }
  }

  & .sections {
    display: flex;
    flex-direction: column;
    gap: 90px;
  }
`;